var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.004C8 11.8669 8.0262 11.7404 8.07859 11.6245C8.13098 11.5086 8.20956 11.3979 8.31434 11.2925L14.4362 5.26877C14.609 5.08959 14.8238 5 15.0806 5C15.2482 5 15.4028 5.04216 15.5442 5.12648C15.6857 5.20553 15.7983 5.31621 15.8821 5.4585C15.9607 5.59552 16 5.74835 16 5.917C16 6.16996 15.9057 6.39394 15.7171 6.58893L10.2004 12.004L15.7171 17.419C15.9057 17.614 16 17.8353 16 18.083C16 18.2569 15.9607 18.4124 15.8821 18.5494C15.7983 18.6864 15.6857 18.7945 15.5442 18.8735C15.4028 18.9578 15.2482 19 15.0806 19C14.8238 19 14.609 18.913 14.4361 18.7391L8.31434 12.7154C8.20956 12.61 8.13098 12.4993 8.07859 12.3834C8.0262 12.2675 8 12.141 8 12.004Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.82a3512843f605db632b27e5cc7ff7c3.svg";
export { ForwardRef as ReactComponent };